import { render, staticRenderFns } from "./Segments.vue?vue&type=template&id=7446a6b2&scoped=true&"
import script from "./Segments.vue?vue&type=script&lang=js&"
export * from "./Segments.vue?vue&type=script&lang=js&"
import style0 from "./Segments.vue?vue&type=style&index=0&id=7446a6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7446a6b2",
  null
  
)

export default component.exports